import { ChatLayoutProvider } from "~/shared/context/ChatLayoutContext";
import { ChatShell } from "~/pages/chat/shell/ChatShell";

export function ChatPage() {
    return (
        <ChatLayoutProvider heroMedia mobileQuickActions>
            <ChatShell />
        </ChatLayoutProvider>
    );
}
